
import {getToken} from '../adalConfig';

export const actionCreators = {

    // REQUEST_CONTACTS 
    requestUsers: () => async (dispatch, getState) => {       
        dispatch({ type: 'REQUEST_USERS' });
        const headers = { Authorization: `Bearer ${getToken()}` };
        const url = `api/User`;
        const response = await fetch(url, {headers});
        const users = await response.json();
        dispatch({ type: 'RECEIVE_USERS', users });
    },
    // ADD_CONTACT
    addUser: (newUser) => async (dispatch, getState) => {
        const headers = { 'Authorization': `Bearer ${getToken()}`,
                            'Content-Type': 'application/json'     
                        };    
        const url = `api/User`;
        const response = await fetch(url, {
            method: 'post',
            body: JSON.stringify(newUser),
            headers
        });
        const user = await response.json();
        dispatch({ type: 'ADD_USER', user });
        return user;
    },
    requestCurrentUserNotifications: () => async (dispatch, getState) => {      
      const headers = { Authorization: `Bearer ${getToken()}` };
      const response = await fetch('/api/user/current', { headers });
      const u = await response.json();
      if(u.login === null) {
        const email = "diego@alperform.com"
        const url = `api/User/${email}`;
        const res =  await fetch(url, {headers});
        const user = await res.json();
        dispatch({ type: 'REQUEST_CURRENT_USER_NOTIFICATIONS', user });
        return user;        
      }else{
        const url = `api/User/${u.login}`;
        const res =  await fetch(url, {headers});
        const user = await res.json();
        dispatch({ type: 'REQUEST_CURRENT_USER_NOTIFICATIONS', user });
        return user;
      }
    },
    // EDIT_CURRENT_USER_NOTIFICATIONS
    editCurrentUserNotifications: (currentUser) => async (dispatch, getState) => {
      const headers = { 'Authorization': `Bearer ${getToken()}`,
                        'Content-Type': 'application/json'     
                        };  
      const url = `api/User/${currentUser.email}`;
      const response = await fetch(url, {
          method: 'put',
          body: JSON.stringify(currentUser),
          headers
      });
      const updates = currentUser;
      
      dispatch({ type: 'EDIT_USER', email: currentUser.email, updates });
  }, 
};




// WEBPACK FOOTER //
// ./src/actions/users.js